// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import communication from './communication.svg';

interface CommunicationIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: CommunicationNames;
}

export function CommunicationIcon({ name, ...props }: CommunicationIconProps) {
  return <Icon {...props} link={communication} name={name} />
}

type CommunicationNames =
  | '3p'
  | 'add_ic_call'
  | 'alternate_email'
  | 'app_registration'
  | 'business'
  | 'call_end'
  | 'call_made'
  | 'call_merge'
  | 'call_missed_outgoing'
  | 'call_missed'
  | 'call_received'
  | 'call_split'
  | 'call'
  | 'cancel_presentation'
  | 'cell_tower'
  | 'cell_wifi'
  | 'chat_bubble_outline'
  | 'chat_bubble'
  | 'chat'
  | 'clear_all'
  | 'co_present'
  | 'comment'
  | 'comments_disabled'
  | 'contact_mail'
  | 'contact_phone'
  | 'contacts'
  | 'desktop_access_disabled'
  | 'dialer_sip'
  | 'dialpad'
  | 'document_scanner'
  | 'domain_disabled'
  | 'domain_verification'
  | 'duo'
  | 'email'
  | 'forward_to_inbox'
  | 'hourglass_bottom'
  | 'hourglass_top'
  | 'hub'
  | 'import_contacts'
  | 'import_export'
  | 'invert_colors_off'
  | 'key_off'
  | 'key'
  | 'live_help'
  | 'location_off'
  | 'location_on'
  | 'mail_lock'
  | 'mail_outline'
  | 'mark_chat_read'
  | 'mark_chat_unread'
  | 'mark_email_read'
  | 'mark_email_unread'
  | 'mark_unread_chat_alt'
  | 'message'
  | 'mobile_screen_share'
  | 'more_time'
  | 'nat'
  | 'no_sim'
  | 'pause_presentation'
  | 'person_add_disabled'
  | 'person_search'
  | 'phone_disabled'
  | 'phone_enabled'
  | 'phone'
  | 'phonelink_erase'
  | 'phonelink_lock'
  | 'phonelink_ring'
  | 'phonelink_setup'
  | 'portable_wifi_off'
  | 'present_to_all'
  | 'print_disabled'
  | 'qr_code_2'
  | 'qr_code_scanner'
  | 'qr_code'
  | 'read_more'
  | 'ring_volume'
  | 'rss_feed'
  | 'rtt'
  | 'screen_share'
  | 'send_time_extension'
  | 'sentiment_satisfied_alt'
  | 'sip'
  | 'speaker_phone'
  | 'spoke'
  | 'stay_current_landscape'
  | 'stay_current_portrait'
  | 'stay_primary_landscape'
  | 'stay_primary_portrait'
  | 'stop_screen_share'
  | 'swap_calls'
  | 'textsms'
  | 'unsubscribe'
  | 'voicemail'
  | 'vpn_key_off'
  | 'vpn_key'
  | 'wifi_calling'
;

